import { axiosJWT } from '@plugins/axios'

export default {
  postNotificationsToken: async (token: string): Promise<void> => {
    await axiosJWT.post('push_tokens', { token })
  },
}
